import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AuthService } from '@kpd/framework-ngx';
import { User } from 'app/shared/models/user';
import { UserFacade } from 'app/shared/services/facades/user.facade';
import { IApplicationWithRoles } from 'app/users/detail/user-details-roles.component';

@Component({
  selector: 'app-user-details-permissions',
  templateUrl: './user-details-permissions.component.html',
})
export class UserDetailsPermissionsComponent implements OnChanges {
  constructor(private authService: AuthService, private userFacade: UserFacade) {}

  @Input()
  item: User;
  loading = false;
  applicationsWithRoles: IApplicationWithRoles[];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.item && this.item instanceof User) {
      this.applicationsWithRoles = [];
      this.loading = true;
      this.userFacade.reloadUser(this.item).subscribe((user: User) => {
        this.item = user;
        this.getUserRoles();
      });
    }
  }

  getUserRoles(): void {
    if (!this.item.getApplicationsWithRoles) {
      return;
    }
    const activeTenantId = this.authService.getTenant().key.id;
    this.applicationsWithRoles = this.item.getApplicationsWithRoles(activeTenantId).map((roleApp) => {
      roleApp.roles.sort((a, b) => a.name.localeCompare(b.name));
      const mappedRoles = roleApp.roles.map((role) => ({
        role: role.name,
        hasRole: false,
        loading: false,
        readOnly: false,
      }));
      return {
        name: roleApp.name,
        roles: mappedRoles,
      };
    });
    this.loading = false;
  }
}
